/* eslint-disable */
import React, { Component } from 'react'
// import PropTypes from 'prop-types';
import { View, Text, TouchableHighlight, Image, ScrollView } from 'react-native'
import styles from './Styles/HeaderAvatarComponentStyle'
import TextComponent from '../Components/TextComponent'
import { Images } from '../Themes/'
import ReadMore from '../Lib/ReadMore'
import { SvgMinusProfile, SvgPlusProfile } from './SvgComponent/'
import { connect } from "react-redux"
import ReadMoreActions from '../Redux/ReadMoreRedux'
import rnTextSize, { TSFontSpecs } from 'react-native-text-size'
import UserActions from "../Redux/UserRedux"
//import FastImage from 'react-native-fast-image'
//import ScrollBlockView from 'react-native-scroll-block-view'

 class HeaderAvatarComponent extends Component {

  readMore = (handlePress) => {
    return (

      <TouchableHighlight style={styles.readerMore} onPress={handlePress}>
        <SvgPlusProfile size={20} />
      </TouchableHighlight>

    );
  }
  hideMore = (handlePress) => {
    return (

      <TouchableHighlight style={styles.readerMore} onPress={handlePress}>
        <SvgMinusProfile size={20} />
      </TouchableHighlight>

    );
  }
  
  componentDidMount() {
  
  
  }
  getHeight =(height)=>{
    
      console.log("bio getHeight = " + height)
      this.props.showHeightBio({height :height + 50})
  }
 
  render() {
    //console.log("render header avatar this.props.refreshAvatar = " + this.props.refreshAvatar + " uri = " + JSON.stringify(this.props.uri))
    var useUri = this.props.uri
    useUri.uri = useUri.uri + "?refreshAvatar=" + this.props.refreshAvatar
    return (

      <View style={styles.avatarContainerRow}>
        <View style={styles.avatarContainer}>
          <TouchableHighlight
            onPress={this.props.onPressAvatar}
            style={styles.avatarBorder} underlayColor="transparent">
            <Image
              style={this.props.online ? styles.avatarOnline : styles.avatar}
              source={useUri/*this.props.uri*/}
            />
          </TouchableHighlight>
        </View>
        
        <ScrollView style={[styles.textDescriptionContainer, {height: 100}]}>
        {!!this.props.text && <Text>
          {this.props.text + "\n\n"} 
          </Text>
        }
        </ScrollView>
       
      </View>


    )
  }
}

// if any place in the app mods the refreshAvatar property of user redux, this component will render
const mapStateToProps = state => {
  return {
    refreshAvatar: state.user.refreshAvatar
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    showHeightBio: (data) => dispatch(ReadMoreActions.showHeightBio(data)),
    
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(HeaderAvatarComponent)